module.exports = __webpack_public_path__ + "static/media/logo.b93f51f0.png";